// Animation utility functions

// Function to check if an element is in viewport
export const isInViewport = (element, offset = 150) => {
    const rect = element.getBoundingClientRect();
    return (
      rect.top <= (window.innerHeight - offset || document.documentElement.clientHeight - offset) &&
      rect.bottom >= 0
    );
  };
  
  // Function to handle scroll animations
  export const handleScrollAnimations = () => {
    const animatedElements = document.querySelectorAll(
      '.fade-in, .slide-in-left, .slide-in-right, .scale-in'
    );
  
    animatedElements.forEach((element) => {
      if (isInViewport(element)) {
        element.classList.add('visible');
      }
    });
  };
  
  // Initialize animations
  export const initAnimations = () => {
    // Initial check for elements in viewport
    handleScrollAnimations();
  
    // Add scroll event listener
    window.addEventListener('scroll', handleScrollAnimations);
  
    // Clean up function
    return () => {
      window.removeEventListener('scroll', handleScrollAnimations);
    };
  };